__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("axios", "1.20.0", () => (__webpack_require__.e("vendors-node_modules_pnpm_axios_1_20_0_node_modules_axios_index_js").then(() => (() => (__webpack_require__(5977))))));
			register("lucide-react", "1.17.0", () => (__webpack_require__.e("vendors-node_modules_pnpm_lucide-react_1_17_0_react_19_2_7_node_modules_lucide-react_dist_esm-2c27ea").then(() => (() => (__webpack_require__(7501))))));
			register("react-dom/client", "19.2.7", () => (__webpack_require__.e("vendors-node_modules_pnpm_react-dom_19_2_7_react_19_2_7_node_modules_react-dom_client_js").then(() => (() => (__webpack_require__(6315))))));
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(4258))), 1);
			register("react-router-dom", "6.30.6", () => (() => (__webpack_require__(3633))), 1);
			register("react/jsx-dev-runtime", "19.2.7", () => (__webpack_require__.e("vendors-node_modules_pnpm_react_19_2_7_node_modules_react_jsx-dev-runtime_js").then(() => (() => (__webpack_require__(7105))))));
			register("react", "19.2.7", () => (() => (__webpack_require__(5739))), 1);
			register("sonner", "2.0.7", () => (__webpack_require__.e("vendors-node_modules_pnpm_sonner_2_0_7_react-dom_19_2_7_react_19_2_7__react_19_2_7_node_modul-8a88bd").then(() => (() => (__webpack_require__(4137))))));
			register("zustand/middleware", "4.5.7", () => (__webpack_require__.e("vendors-node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustan-8edc0c").then(() => (() => (__webpack_require__(2422))))));
			register("zustand/vanilla", "4.5.7", () => (__webpack_require__.e("node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustand_esm_va-66cfe7").then(() => (() => (__webpack_require__(4219))))));
			register("zustand", "4.5.7", () => (__webpack_require__.e("node_modules_pnpm_zustand_4_5_7__types_react_19_2_16_react_19_2_7_node_modules_zustand_esm_in-b48b16").then(() => (() => (__webpack_require__(2154))))));
			initExternal(8636);
			initExternal(4740);
			initExternal(8646);
			initExternal(5184);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};